"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/index.tsx"; function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }require('core-js/stable');
require('regenerator-runtime/runtime');
require('intersection-observer');
require('whatwg-fetch');

var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _client = require('react-dom/client'); var _client2 = _interopRequireDefault(_client);
var _reactredux = require('react-redux');

var _react3 = require('@sentry/react'); var Sentry = _interopRequireWildcard(_react3);

var _store = require('web/store');
var _store3 = require('shared/store');

var _chat = require('web/chat'); var _chat2 = _interopRequireDefault(_chat);
var _patientResponse = require('web/patientResponse'); var _patientResponse2 = _interopRequireDefault(_patientResponse);
var _formFill = require('web/formFill'); var _formFill2 = _interopRequireDefault(_formFill);

require('../styles/index.scss');

var _chat3 = require('web/store/rootReducers/chat'); var _chat4 = _interopRequireDefault(_chat3);
var _patientResponse3 = require('web/store/rootReducers/patientResponse'); var _patientResponse4 = _interopRequireDefault(_patientResponse3);









var _app = require('web/services/app');
var _posthog = require('web/services/posthog'); var _posthog2 = _interopRequireDefault(_posthog);
var _redactLinks = require('web/services/redactLinks');
var _desktopShell = require('web/services/desktopShell');
var _chat5 = require('shared/actions/chat');
var _messageUploadTransport = require('web/services/messageUploadTransport');
var _templatesAction = require('shared/services/composer/templatesAction');

if (REACT_SCAN_ENABLED) {
  require('./devtools/loadReactScan')
}

log.setLevel(LOG_LEVEL)
_posthog2.default.init()
_chat5.setMessageUploadTransport.call(void 0, _messageUploadTransport.browserMessageUploadTransport)
// Lane D: "Templates" in the composer's + menu (staff only).
_templatesAction.registerTemplatesComposerAction.call(void 0, )

_desktopShell.markInsetTitleBar.call(void 0, )

if (window.ELECTRON) {
  _posthog2.default.capture('desktop_app_opened', {
    app_version: window.ELECTRON.version,
    platform: window.navigator.platform,
  })
}

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: BUILD,
    beforeBreadcrumb (breadcrumb) {
      return breadcrumb.category === "action" ? breadcrumb : null
    },
    // Form and patient-link codes in the page URL open the form or the chat.
    beforeSend: _redactLinks.redactSentryEvent,
  })
}






const AppWrapper = ({ store, children }) => (
  _react2.default.createElement(_reactredux.Provider, { store: store, __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}},  children )
)

// The store is created and registered with setStore during the first render,
// as the class's render did. Root has no props or state and renders once; the
// lazy initialiser keeps it to one store even if it ever re-rendered.
const createApp = () => {
  switch (_app.getAppMode.call(void 0, )) {
    case _app.MWEB_CHAT_MODE:
    case _app.WEB_CHAT_MODE:
    case _app.ELECTRON_CHAT_MODE:
    case _app.LOU_VIDEO_MEETING_MODE: {
      const store = _store.configureStore(_chat4.default)
      _store3.setStore(store)
      return (
        _react2.default.createElement(AppWrapper, { store: store, __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
          , _react2.default.createElement(_chat2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} )
        )
      )
    }
    case _app.PATIENT_RESPONSE_MODE: {
      const store = _store.configureStore(_patientResponse4.default)
      _store3.setStore(store)
      return (
        _react2.default.createElement(AppWrapper, { store: store, __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
          , _react2.default.createElement(_patientResponse2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 103}} )
        )
      )
    }
    // The family's form link: its own small store and its own login.
    case _app.FORM_FILL_MODE: {
      const store = _store.configureStore(_patientResponse4.default)
      _store3.setStore(store)
      return (
        _react2.default.createElement(AppWrapper, { store: store, __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
          , _react2.default.createElement(_formFill2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 113}} )
        )
      )
    }
    default: return null
  }
}

const Root = () => {
  const [app] = _react.useState.call(void 0, createApp)
  return app
}

const container = document.getElementById('root')
if (container) {
  const root = _client2.default.createRoot(container)
  root.render(_react2.default.createElement(Root, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 129}} ))
}
